import React from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'
import colors from '../../styles/colors'

const SubmitModal = ({ show, handleClose, title, children, handleSubmit }) => {
  return (
    <ModalContainer show={show} onHide={handleClose}>
      {/* <Modal.Header className="px-4" closeButton> */}
      <Modal.Header closeButton>
        <ModalTitle className="ms-auto"> {title}</ModalTitle>
      </Modal.Header>
      {/* <Modal.Body className="text-center m-auto">{children}</Modal.Body> */}
      <Modal.Body style={{ padding: 0 }}>
        <ModalWrapper>{children}</ModalWrapper>
      </Modal.Body>
      <ModalFooterWrapper>
        <ModalFooter />
        <SubmitButton onClick={handleSubmit}>
          <SubmitButtonTxt>적용</SubmitButtonTxt>
        </SubmitButton>
      </ModalFooterWrapper>
    </ModalContainer>
  )
}

export default SubmitModal

const ModalContainer = styled(Modal)`
  .modal-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-content {
    width: 360px;
    /* height: 354px; */
    object-fit: contain;
    background-color: #fff;
  }
  .modal-header {
    padding: 20px;
    border: 0;
    color: ${colors.BK};
  }
  .modal-body {
    flex: unset;
  }
  .modal-footer > * {
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
  }
  .btn-close {
    box-shadow: none;
  }
`
const ModalTitle = styled(Modal.Title)`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.BK};
`
const ModalFooterWrapper = styled(Modal.Footer)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: none;
  padding-top: 0;
  margin-top: 5px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
`
const ModalFooter = styled.div`
  /* width: 632px; */
  width: 100%;
  height: 1px;
  /* border: solid 1px #f3f3f3;
  background-color: #e5e5e5; */
  background-color: ${colors.G3};
  margin-bottom: 20px;
`
const SubmitButton = styled.div`
  /* width: 320px; */
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background-color: ${colors.mainG};
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 15px; */
  margin-bottom: 0;
  cursor: pointer;
`
const SubmitButtonTxt = styled.span`
  font-family: NotoSansKR;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.W1};
`

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0;
`
